/**
 * <h44-wish-button data-handle>: toggles one product handle in the browser-local
 * wishlist and mirrors the saved state on its inner button via aria-pressed.
 */
const KEY = 'h44-wishlist';
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };
const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {} window.dispatchEvent(new CustomEvent('h44:wishlist-change')); };

class H44WishButton extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.#sync();
    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('button')) return;
      event.preventDefault();
      event.stopPropagation();
      const handle = this.dataset.handle;
      if (!handle) return;
      const list = read();
      const index = list.indexOf(handle);
      if (index >= 0) list.splice(index, 1); else list.unshift(handle);
      write(list);
    }, { signal });
    window.addEventListener('h44:wishlist-change', () => this.#sync(), { signal });
    window.addEventListener('storage', (event) => { if (event.key === KEY) this.#sync(); }, { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    this.querySelector('button')?.setAttribute('aria-pressed', String(read().includes(this.dataset.handle)));
  }
}

if (!customElements.get('h44-wish-button')) {
  customElements.define('h44-wish-button', H44WishButton);
}
